export async function throwIfNotOk(res: Response, fallback: string): Promise<void> {
  if (res.ok) return;
  const body = await res.json().catch(() => null);
  // `validateBody` already spells every field problem out in `error`.
  throw new Error(body?.error || body?.message || fallback);
}

export async function apiGet<T>(url: string, fallback: string): Promise<T> {
  const res = await fetch(url, { credentials: "include" });
  await throwIfNotOk(res, fallback);
  return res.json() as Promise<T>;
}

export async function apiSend<T>(
  url: string,
  method: "POST" | "PUT" | "PATCH" | "DELETE",
  body: unknown,
  fallback: string,
): Promise<T> {
  const res = await fetch(url, {
    method,
    credentials: "include",
    headers: body !== undefined ? { "Content-Type": "application/json" } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  await throwIfNotOk(res, fallback);
  return res.json().catch(() => ({} as T));
}
